import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';

import { appRoutes } from './app.routes';
import { httpInterceptor } from './interceptor-http.service';

import { registerLocaleData } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';

// LS-COMMON Dependencies
import { provideGoogleService } from '@ls-commons/auth';
// import { utilsCacheInterceptor } from '@ls-commons/utils/interceptors';
import { ComponentsConfigModule } from '@ls-commons/components/config';
import { environment } from '../environments/environment';

// import Aura from '@primeng/themes/aura';
// import Nora from '@primeng/themes/nora';
// import Material from '@primeng/themes/material';
import { CustomTheme } from '../themes/custom-theme';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { USER_SERVICE_TOKEN } from '@ls-commons/models';
import { FILES_APIV3_DOMAIN, FILES_PANEL_DOMAIN } from '@ls-commons/users';
import { UserService } from '@ls-commons/users/services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(ComponentsConfigModule, DynamicDialogModule),
    DialogService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    MessageService,
    ConfirmationService,
    provideHttpClient(withInterceptors([httpInterceptor()])), // , utilsCacheInterceptor()
    provideRouter(appRoutes),
    provideAnimations(),
    provideAnimationsAsync(),
    provideStore(),
    provideEffects(),
    provideRouterStore(),
    provideGoogleService(environment.GOOGLE_ID),
    providePrimeNG({
      theme: {
        preset: CustomTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.app-dark',
          cssLayer: false,
        },
      },
      ripple: true,
    }),
    {
      provide: LOCALE_ID,
      useValue: document.documentElement.lang,
    },
    {
      provide: FILES_PANEL_DOMAIN,
      useValue: environment.urlRestList.PANEL,
    },
    {
      provide: FILES_APIV3_DOMAIN,
      useValue: environment.urlRestList.API,
    },

    {
      provide: USER_SERVICE_TOKEN,
      useClass: UserService,
    },
  ],
};
